import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import UpcomingDueCustomers from './UpcomingDueCustomers';
import InstallmentSummaryCards from './InstallmentSummaryCards';
import GreetingHeader from './GreetingHeader';
import { Wallet, CreditCard, TrendingUp, TrendingDown, DollarSign, AlertCircle, Package } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AccountantDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/dashboard/accountant-stats`, { withCredentials: true })
      .then(({ data }) => setStats(data))
      .catch(() => setStats({}))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-96 text-slate-400">Loading dashboard...</div>;

  const cards = [
    { title: 'Cash Balance', value: `PKR ${(stats?.cash_balance || 0).toLocaleString()}`, icon: Wallet, color: 'text-emerald-500', testId: 'acc-stat-cash' },
    { title: 'Bank Balance', value: `PKR ${(stats?.bank_balance || 0).toLocaleString()}`, icon: CreditCard, color: 'text-blue-500', testId: 'acc-stat-bank' },
    { title: 'Month Inflow', value: `PKR ${(stats?.month_inflow || 0).toLocaleString()}`, icon: TrendingUp, color: 'text-emerald-500', testId: 'acc-stat-inflow' },
    { title: 'Month Outflow', value: `PKR ${(stats?.month_outflow || 0).toLocaleString()}`, icon: TrendingDown, color: 'text-red-500', testId: 'acc-stat-outflow' },
    { title: 'Total Investment', value: `PKR ${(stats?.investment || 0).toLocaleString()}`, icon: Package, color: 'text-amber-500', testId: 'acc-stat-investment' },
    { title: 'Total Sales', value: `PKR ${(stats?.sales || 0).toLocaleString()}`, icon: TrendingUp, color: 'text-emerald-500', testId: 'acc-stat-sales' },
    { title: 'Total Profit', value: `PKR ${(stats?.profit || 0).toLocaleString()}`, icon: TrendingUp, color: (stats?.profit || 0) >= 0 ? 'text-emerald-500' : 'text-red-500', testId: 'acc-stat-profit' },
    { title: 'Total Recovered', value: `PKR ${(stats?.total_recovered || 0).toLocaleString()}`, icon: DollarSign, color: 'text-emerald-500', testId: 'acc-stat-recovered' },
    { title: 'Outstanding', value: `PKR ${(stats?.outstanding || 0).toLocaleString()}`, icon: AlertCircle, color: 'text-yellow-500', testId: 'acc-stat-outstanding' },
  ];

  return (
    <div className="space-y-6" data-testid="accountant-dashboard">
      <GreetingHeader
        testId="acc-greeting"
        fallbackName="Accountant"
        subtitle="Accountant Dashboard · Full financial view — inflow, outflow, profit and recovery"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c, i) => (
          <Card key={i} className="bg-slate-900 border-slate-800 hover:-translate-y-1 transition-transform" data-testid={c.testId}>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium text-slate-400">{c.title}</CardTitle>
              <c.icon className={`h-4 w-4 ${c.color}`} />
            </CardHeader>
            <CardContent><div className="text-2xl font-bold text-white">{c.value}</div></CardContent>
          </Card>
        ))}
      </div>
    <InstallmentSummaryCards />
      <UpcomingDueCustomers />

    </div>
  );
}
